import { isUndNullEmp } from '../../helpers/main';

export class RequestAccountReq {
    constructor(
        _firstName = '',
        _lastName = '',
        _userName = '',
        _phoneNumber = '',
        _name = '',
        _rif = '',
        _email = '',
        _phones = '',
        _department = '',
        _position = '',
        _reCaptchaToken = '',
    ) {
        this.firstName = _firstName;
        this.lastName = _lastName;
        this.userName = _userName;
        this.phoneNumber = _phoneNumber;
        this.name = _name;
        this.rif = _rif;
        this.email = _email;
        this.phones = _phones;
        this.department = _department;
        this.position = _position;
        this.reCaptchaToken = _reCaptchaToken;
    }

    static getClassName = () => {
        return 'RequestAccountReq - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    //Id: 0,
                    FirstName: 3,
                    LastName: 3,
                    UserName: 10,
                    PhoneNumber: 7,
                    Name: 5,
                    Rif: 7,
                    Phones: 7,
                    Email: 10,
                    Department: 3,
                    Position: 3,
                    //StatusId: 1,
                    DateCreate: 3,
                    DateProcess: 3,
                    //Remark: 1,
                },
                max: {
                    //Id: 0,
                    FirstName: 100,
                    LastName: 100,
                    UserName: 100,
                    PhoneNumber: 30,
                    Name: 100,
                    Rif: 12,
                    Phones: 30,
                    Email: 100,
                    Department: 30,
                    Position: 30,
                    //StatusId: 0,
                    DateCreate: 30,
                    DateProcess: 30,
                    //Remark: 30,
                },
            };
        } else {
            return {
                min: {
                    //id: 0,
                    firstName: 3,
                    lastName: 3,
                    userName: 10,
                    phoneNumber: 7,
                    name: 5,
                    rif: 7,
                    phones: 7,
                    email: 10,
                    department: 3,
                    position: 3,
                    //statusId: 1,
                    dateCreate: 3,
                    dateProcess: 3,
                    //remark: 1,
                },
                max: {
                    //id: 0,
                    firstName: 100,
                    lastName: 100,
                    userName: 100,
                    phoneNumber: 30,
                    name: 100,
                    rif: 12,
                    phones: 30,
                    email: 100,
                    department: 30,
                    position: 30,
                    //statusId: 0,
                    dateCreate: 30,
                    dateProcess: 30,
                    //remark: 30,
                },
            };
        }
    }

    static class = (obj = {}) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName })?.result) {
            return new RequestAccountReq(
                obj.firstName,
                obj.lastName,
                obj.userName,
                obj.phoneNumber,
                obj.name,
                obj.rif,
                obj.email,
                obj.phones,
                obj.department,
                obj.position,
                obj.reCaptchaToken,
            );
        } else {
            return new RequestAccountReq();
        }
    }
}

export class RequestAccountRes {
    constructor(
        _id = 0,
        _firstName = '',
        _lastName = '',
        _userName = '',
        _phoneNumber = '',
        _name = '',
        _rif = '',
        _email = '',
        _phones = '',
        _department = '',
        _position = '',
        _statusId = 0,
        _dateCreate = '',
        _dateProcess = '',
        _remark = '',
    ) {
        this.id = _id;
        this.firstName = _firstName;
        this.lastName = _lastName;
        this.userName = _userName;
        this.phoneNumber = _phoneNumber;
        this.name = _name;
        this.rif = _rif;
        this.email = _email;
        this.phones = _phones;
        this.department = _department;
        this.position = _position;
        this.statusId = _statusId;
        this.dateCreate = _dateCreate;
        this.dateProcess = _dateProcess;
        this.remark = _remark;
    }

    static getClassName = () => {
        return 'RequestAccountRes - class';
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName })?.result) {
            if (upperCase) {
                return new RequestAccountRes(
                    obj.Id,
                    obj.FirstName,
                    obj.LastName,
                    obj.UserName,
                    obj.PhoneNumber,
                    obj.Name,
                    obj.Rif,
                    obj.Email,
                    obj.Phones,
                    obj.Department,
                    obj.Position,
                    obj.StatusId,
                    obj.DateCreate,
                    obj.DateProcess,
                    obj.Remark,
                );
            } else {
                return new RequestAccountRes(
                    obj.id,
                    obj.firstName,
                    obj.lastName,
                    obj.userName,
                    obj.phoneNumber,
                    obj.name,
                    obj.rif,
                    obj.email,
                    obj.phones,
                    obj.department,
                    obj.position,
                    obj.statusId,
                    obj.dateCreate,
                    obj.dateProcess,
                    obj.remark,
                );
            }
        } else {
            return new RequestAccountRes();
        }
    }
}

export class RequestAccountMonitorReq {
    constructor(
        _userName = '',
        _email = '',
        _reCaptchaToken = '',
    ) {
        this.userName = _userName;
        this.email = _email;
        this.reCaptchaToken = _reCaptchaToken;
    }

    static getClassName = () => {
        return 'RequestAccountMonitorReq - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    UserName: RequestAccountReq.minMaxLength(true).min.UserName,
                    Email: RequestAccountReq.minMaxLength(true).min.Email,
                    ReCaptchaToken: 450,
                },
                max: {
                    UserName: RequestAccountReq.minMaxLength(true).max.UserName,
                    Email: RequestAccountReq.minMaxLength(true).max.Email,
                    ReCaptchaToken: 450,
                }
            };
        } else {
            return {
                min: {
                    userName: RequestAccountReq.minMaxLength(false).min.userName,
                    email: RequestAccountReq.minMaxLength(false).min.emailmail,
                    reCaptchaToken: 450,
                },
                max: {
                    userName: RequestAccountReq.minMaxLength(false).max.userName,
                    email: RequestAccountReq.minMaxLength(false).max.email,
                    reCaptchaToken: 450,
                }
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName })?.result) {
            if (upperCase) {
                return new RequestAccountMonitorReq(
                    obj.UserName,
                    obj.Email,
                    obj.ReCaptchaToken,
                );
            } else {
                return new RequestAccountMonitorReq(
                    obj.userName,
                    obj.email,
                    obj.reCaptchaToken,
                );
            }
        } else {
            return new RequestAccountMonitorReq();
        }
    }
}